import { prefix } from '../module';

export const MESSAGE_CENTER_OPENED = prefix('MESSAGE_CENTER_OPENED');
export const MESSAGE_CENTER_CLOSED = prefix('MESSAGE_CENTER_CLOSED');
